module.exports = __webpack_public_path__ + "img/id-card_fill.06cf86c0.svg";